export const KCAL_UNIT = 2;
